export default __webpack_public_path__ + "7dc1af865ad282eb5f0d5142577b9d15.svg";